module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"languages":["fr","en"],"defaultLanguage":"fr","siteUrl":"https://www.seabarts.com","i18nextOptions":{"debug":false,"fallbackLng":"fr","supportedLngs":["fr","en"],"defaultNS":"common","interpolation":{},"detection":{"order":["path"],"caches":[]}},"redirect":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
